import { Plan } from '@models/membership/Plan'
import { useAppSelector } from '@store/hooks'
import { selectPlanById } from '@store/membership/PlanReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<Plan> & {
  /** Also display the name of the program the plan belongs to */
  showProgram?: boolean
}

const PlanTag: FC<Props> = ({ id, model, showProgram = false }) => {
  const item = model ? model : useAppSelector(selectPlanById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space.Compact>
      {showProgram && item.program && (
        <Tag color="blue">{item.program.en.name}</Tag>
      )}
      <Tag>{item.en.name}</Tag>
    </Space.Compact>
  )
}

type PlanTagType = { Tag: typeof PlanTag }

export { PlanTag, type PlanTagType }
